import {ACTIONS} from "@intellectability/platform-common/constants";

/** @type {import("@intellectability/platform-common/router").RouterConfig} */
const routerConfig = {
    spa: false,
    appPath: "index.php",
    routes: [
        {
            layout: "null",
            path: `?action=${ACTIONS.CHECKLISTS_SAM_GLOBAL_LIST}`,
            render: () => import("../../Pages/Nursing/SelfAdministrationOfMedication/List/SelfAdministrationOfMedicationList.svelte"),
            title: "SAMs List"
        }
    ]
};

export default routerConfig;

